<template>
  <el-dialog
    v-model="dialogFormVisible"
    :close-on-click-modal="false"
    :title="title"
    width="80%"
    @close="close"
  >
    <el-form ref="form" label-width="100px" :model="form" :rules="rules">
      <el-form-item label="州名称" prop="title">
        <el-input v-model="form.title" class="custom-input" />
      </el-form-item>
      <el-form-item label="经度" prop="lng">
        <el-input v-model="form.lng" class="custom-input" />
      </el-form-item>
      <el-form-item label="纬度" prop="lat">
        <el-input v-model="form.lat" class="custom-input" />
      </el-form-item>
      <el-form-item label="排序" prop="order">
        <el-input-number v-model="form.order" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { createProvince, editProvince } from '@/api/apartment'
export default {
  name: 'Edit',
  emits: ['fetch-data'],
  data() {
    return {
      list: [],
      form: {
        title: '',
        lat: '',
        lng: '',
        order: 0,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入州名称' }],
        lat: [{ required: true, trigger: 'blur', message: '请输入纬度' }],
        lng: [{ required: true, trigger: 'blur', message: '请输入经度' }],
      },
      title: '',
      dialogFormVisible: false,
    }
  },
  methods: {
    async showEdit(row) {
      if (row.provinceId) {
        this.title = '编辑州'
        this.form = Object.assign(this.form, {
          order: row.basic && row.basic.order,
          lat: row.basic && row.basic.lat,
          lng: row.basic && row.basic.lng,
          provinceId: row.provinceId,
          title: row.title
        })
      } else {
        this.title = '新增州'
      }
      this.dialogFormVisible = true
      // Lat: 37.5216 Lon: -77.1175
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    async save() {
      this.$refs['form'].validate(async (valid) => {
        const isEdit = !!this.form.provinceId
        this.$baseConfirm(
          `你确定${isEdit ? '修改' : '新增'}吗`,
          null,
          async () => {
            isEdit
              ? await editProvince({ ...this.form })
              : await createProvince({ ...this.form })
            this.$baseMessage(
              `${isEdit ? '修改' : '新增'}成功`,
              'success',
              false,
              'vab-hey-message-success'
            )
            this.$emit('fetch-data')
            this.close()
          }
        )
      })
    },
  },
}
</script>

<style style="scss">
.custom-input {
  width: 500px;
}
</style>
